import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSOCCodes } from "../../redux/actions/lookups/SocCodes";

const useSocCodes = () => {
  const dispatch = useDispatch();
  const socCodesFromStore = useSelector((state) => state.allSocCodes?.socCodes);

  useEffect(() => {
    if (!socCodesFromStore || socCodesFromStore.length === 0) {
      dispatch(getSOCCodes());
    }
  }, [dispatch, socCodesFromStore]);

  return socCodesFromStore || [];
};

export default useSocCodes;
